import {createSlice} from "@reduxjs/toolkit";

const initialInvoiceOrdersState = {
  listLoading: false,
  totalCount: 0,
  pageCount: 0,
  entities: null,
  error: null,
};
export const callTypesEditAndSend = {
  list: "list",
  action: "action"
};
const getIndex = (array, invoiceOrderID) => {
  const mappedArray = array.map(item => item._id);
  return mappedArray.indexOf(invoiceOrderID);
}

export const invoiceOrdersEditAndSendSlice = createSlice({
  name: "invoiceOrdersEditAndSend",
  initialState: initialInvoiceOrdersState,
  reducers: {
    invoiceOrdersFetched: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    invoiceOrdersAppended: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    invoiceOrderEdited: (state, action) => {
      const {canCreate, createdAt, customerName, phone, totalAmount, statusText, status, _id} = action.payload;
      const index = getIndex(state.entities, _id);
      if (Boolean(state.entities)) {
        state.entities[index].canCreate = canCreate;
        state.entities[index].createdAt = createdAt;
        state.entities[index].customerName = customerName;
        state.entities[index].phone = phone;
        state.entities[index].total = totalAmount;
        state.entities[index].statusText = statusText;
        state.entities[index].status = status;
        state.entities[index]._id = _id;
      }
    },
    invoiceOrderCanCreateEdited: (state, action) => {
      const {canCreate, status, statusText, _id} = action.payload.data;
      const index = getIndex(state.entities, _id);
      state.listLoading = false;
      if (Boolean(state.entities)) {
        state.entities[index].canCreate = canCreate;
        state.entities[index].statusText = statusText;
        state.entities[index].status = status;
      }
    },
    invoiceOrderStatusEdited: (state, action) => {
      const {data} = action.payload;
      state.listLoading = false;
      if (Boolean(state.entities) && Array.isArray(data)) {
        data.forEach(item => {
          state.entities.forEach(entitiesItem => {
            if (item._id === entitiesItem._id) {
              entitiesItem.canCreate = item.canCreate;
              entitiesItem.status = item.status;
              entitiesItem.statusText = item.statusText;
              entitiesItem.rivhitStatusText = item.message;
            }
          })
        })
      }
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypesEditAndSend.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.invoiceOrdersError = null;
      if (action.payload.callType === callTypesEditAndSend.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
